import { createFileRoute } from "@tanstack/react-router";
import { LocationPage, locationImages, locationJsonLd } from "@/components/LocationPage";

export const config = {
  slug: "indirapuram-ghaziabad",
  tagline:
    "Healic Hospital Indirapuram — trusted multispecialty care in Ahinsa Khand 2 for Vaishali, Vasundhara, Noida Extension and Ghaziabad families.",
  hours: "7 Am to 10 Pm\u00a0",
  highlights: [
    "Located in Saya Zenith, near CISF Camp",
    "Senior surgeons across General Surgery & Ortho",
    "In-house pathology and radiology",
    "Convenient OPD for Indirapuram & Vaishali",
  ],
  excludeSpecialties: ["ophthalmology"],
  faqs: [
    { q: "Where exactly is the Indirapuram branch?", a: "C-3, Saya Zenith, Plot GH-11, near CISF Camp, Ahinsa Khand 2, Indirapuram, Ghaziabad." },
    { q: "Do you handle planned laparoscopic surgery?", a: "Yes, our General Surgery team performs daily laparoscopic hernia, gallbladder and piles procedures." },
    { q: "Is parking available?", a: "Yes, on-site parking is available at the Saya Zenith complex." },
    { q: "Which areas does this branch serve?", a: "Indirapuram, Vaishali, Vasundhara, Kaushambi, Noida Extension and nearby." },
  ],
};

export const Route = createFileRoute("/locations/indirapuram-ghaziabad")({
  head: () => ({
    meta: [
      { title: "Healic Multispeciality Hospital Indirapuram, Ghaziabad — Multispecialty Care" },
      { name: "description", content: "Surgery, gynae, ortho, ENT and 7 Am to 12 Am emergency at Healic Hospital Indirapuram, Ghaziabad. Visit us at Saya Zenith." },
      { property: "og:title", content: "Healic Multispeciality Hospital Indirapuram, Ghaziabad" },
      { property: "og:description", content: "Trusted multispecialty hospital in Indirapuram — daily surgeries, diagnostics and 7 Am to 12 Am ER." },
      { property: "og:url", content: "https://healic.in/locations/indirapuram-ghaziabad" },
      { property: "og:image", content: locationImages["indirapuram-ghaziabad"] },
    ],
    links: [{ rel: "canonical", href: "https://healic.in/locations/indirapuram-ghaziabad" }],
    scripts: locationJsonLd(config),
  }),
  component: () => <LocationPage config={config} />,
});
